import useScreenSize from '../functions/ScreenSize';

function Tanuki (){
    const screenSize = useScreenSize();
    
    return(
        <iframe src="https://tanuki.click"  style={{width:screenSize.fullWidth, height:screenSize.height}} height="100em" frameBorder="0" title="Tanuki - QR Generator and link shortner"></iframe>
    )
}

export default Tanuki
